import React, { FC } from 'react';
import InsertDriveFileOutlinedIcon from '@mui/icons-material//InsertDriveFileOutlined';
import { Box } from '@mui/material';
import { isUndefined } from 'lodash';
import { DOCUMENT_REQUEST_CATEGORY, QUESTIONNAIRE_REQUEST_CATEGORY } from 'common/constants/process-management';
import { Task } from 'common/types/firm';
import { CurrentInformationRequest } from 'dashboard409a/pages/Information/CurrentRequestedDocumentsAndQuestions/types';
import { CustomTaskBox } from 'pages/Funds/components/ProcessManagement/CustomTaskBox';
import { TaskCellProps } from './types';

const TaskCell: FC<TaskCellProps> = ({ companySlug, companyName, fundName, measurementDateName, tasksProgress }) => {
  // Find company and measurement date
  const company = tasksProgress?.companies?.find(c => c.name === companyName);
  const measurementDate = company?.company_measurement_dates?.find(
    md => md.measurement_date?.name === (measurementDateName as unknown as string)
  );

  if (!measurementDate?.tasks?.length) {
    return null;
  }

  // Get tasks
  const { tasks } = measurementDate;
  const documentTask = tasks.find(t => Number(t.category) === Number(DOCUMENT_REQUEST_CATEGORY)) as CurrentInformationRequest | undefined;
  const questionnaireTask = tasks.find(t => Number(t.category) === Number(QUESTIONNAIRE_REQUEST_CATEGORY)) as CurrentInformationRequest | undefined;

  // Create task objects
  const createTask = (task: CurrentInformationRequest | undefined, category: number): Task | undefined => {
    if (!task?.progress) {
      return undefined;
    }

    
    const progress = task.progress as unknown as { completed: number; total: number };
    return {
      id: task.id || 0,
      summary: task.summary || '',
      progress: { completed: progress.completed, total: progress.total },
      created_at: new Date(),
      task: {
        id: task.id || 0,
        category,
        summary: task.summary || ''
      }
    } as unknown as Task;
  };

  const latestDocumentTask = createTask(documentTask, DOCUMENT_REQUEST_CATEGORY);
  const latestQuestionnaireTask = createTask(questionnaireTask, QUESTIONNAIRE_REQUEST_CATEGORY);

  if (isUndefined(latestDocumentTask) && isUndefined(latestQuestionnaireTask)) {
    return null;
  }

  return (
    <Box display="flex" justifyContent="center">
      {latestDocumentTask && (
        <CustomTaskBox
          companyName={companyName}
          fundName={fundName}
          measurementDateName={measurementDateName}
          task={latestDocumentTask}
          companySlug={companySlug}
          isDocuments>
          <InsertDriveFileOutlinedIcon />
        </CustomTaskBox>
      )}
      {latestQuestionnaireTask && (
        <CustomTaskBox
          companyName={companyName}
          fundName={fundName}
          measurementDateName={measurementDateName}
          task={latestQuestionnaireTask}
          companySlug={companySlug}>
          ?
        </CustomTaskBox>
      )}
    </Box>
  );
};

export default TaskCell;
